// import api from './api'; // Non utilisé pour l'instant

export interface User {
  id: string | number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name?: string;
  is_active: boolean;
  is_staff?: boolean;
  is_superuser?: boolean;
  date_joined?: string;
  last_login?: string;
  role?: { name: string };
  default_site?: string;
  site?: {
    id: string | number;
    nom: string;
  };
}

export interface UserResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: User[];
}

class UserService {
  // Récupérer tous les utilisateurs du site actuel
  async getSiteUsers(): Promise<UserResponse> {
    try {
      // TODO: Implémenter l'endpoint /users/ dans le backend
      // Pour l'instant, utiliser des données mockées
      console.warn('⚠️ Utilisation de données mockées pour les utilisateurs du site - endpoint /users/ non implémenté');
      
      const mockUsers: User[] = [
        {
          id: 1,
          username: 'admin',
          email: 'admin@cajou.ci',
          first_name: 'Admin',
          last_name: 'Système',
          full_name: 'Admin Système',
          is_active: true,
          is_staff: true,
          is_superuser: false,
          date_joined: '2024-01-01T00:00:00Z',
          last_login: '2024-12-20T10:30:00Z',
          role: { name: 'ADMINISTRATEUR' },
          default_site: 'Site Principal'
        },
        {
          id: 2,
          username: 'operateur1',
          email: 'operateur1@cajou.ci',
          first_name: 'Jean',
          last_name: 'Dupont',
          full_name: 'Jean Dupont',
          is_active: true,
          is_staff: false,
          is_superuser: false,
          date_joined: '2024-02-01T00:00:00Z',
          last_login: '2024-12-20T09:15:00Z',
          role: { name: 'OPERATEUR' },
          default_site: 'Site Principal'
        }
      ];
      
      return {
        count: mockUsers.length,
        next: null,
        previous: null,
        results: mockUsers
      };
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs:', error);
      throw error;
    }
  }

  // Récupérer les utilisateurs par site
  async getUsersBySite(_siteId: number): Promise<UserResponse> {
    try {
      // TODO: Implémenter l'endpoint /users/ dans le backend
      // Pour l'instant, utiliser des données mockées
      console.warn('⚠️ Utilisation de données mockées pour les utilisateurs par site - endpoint /users/ non implémenté');
      
      // Retourner les mêmes données mockées pour tous les sites
      return this.getSiteUsers();
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs du site:', error);
      throw error;
    }
  }

  // Rechercher des utilisateurs
  async searchUsers(query: string): Promise<UserResponse> {
    try {
      // TODO: Implémenter l'endpoint /users/ dans le backend
      // Pour l'instant, utiliser des données mockées avec filtrage
      console.warn('⚠️ Utilisation de données mockées pour la recherche d\'utilisateurs - endpoint /users/ non implémenté');
      
      const allUsers = await this.getSiteUsers();
      
      if (!query || query.length < 2) {
        return allUsers;
      }
      
      const searchLower = query.toLowerCase();
      const filteredUsers = allUsers.results.filter(user => 
        user.username.toLowerCase().includes(searchLower) ||
        user.first_name.toLowerCase().includes(searchLower) ||
        user.last_name.toLowerCase().includes(searchLower) ||
        user.email.toLowerCase().includes(searchLower)
      );
      
      return {
        count: filteredUsers.length,
        next: null,
        previous: null,
        results: filteredUsers
      };
    } catch (error) {
      console.error('Erreur lors de la recherche d\'utilisateurs:', error);
      throw error;
    }
  }
}

export default new UserService();
